import { createSlice } from "@reduxjs/toolkit";
import { loginFetch } from "./funtions";
import { REQUEST_STATUS } from "../../../constant/common-constants";

export interface signIn {
  email: string;
  password: string;
}
export interface ILoginState {
  loginList: signIn;
  status: any;
  errors: any;
  loading: boolean;
  isAuthenticated: boolean;
  userEmail: string;
}
let userData = {
  userEmail: "",
  storageType: "sessionStorage",
  token: "",
};
const initialState: ILoginState = {
  loginList: {
    email: "",
    password: "",
  },
  isAuthenticated: false,
  status: REQUEST_STATUS.IDLE, // idle, pending, succeeded, failed
  errors: "",
  loading: false,
  userEmail: userData.userEmail,
};

const rememberMeState = {
  rememberMeState: false,
};
let globalRememberMe = false;

const signinSlice = createSlice({
  name: "loginin",
  initialState,
  reducers: {
    setLogin(state: any, action) {
      state = action.payload;
      state.isAuthenticated = true;
      if (globalRememberMe) {
        userData.storageType = "localStorage";
        localStorage.setItem("userData", JSON.stringify(userData));
      } else {
        sessionStorage.setItem("userData", JSON.stringify(userData));
      }
    },
  },
  extraReducers(builder) {
    builder.addCase(loginFetch.fulfilled, (state, action) => {
      state.status = REQUEST_STATUS.SUCCEEDED;
      state.loginList = action.payload;
      state.loading = false;
    });
    builder.addCase(loginFetch.rejected, (state, action) => {
      state.status = REQUEST_STATUS.FAILED;
      state.errors = action.payload;
      state.loading = false;
    });
    builder.addCase(loginFetch.pending, (state) => {
      state.status = REQUEST_STATUS.PENDING;
      state.loading = true;
    });
  },
});

const rememeberMeSlice = createSlice({
  name: "rememberMe",
  initialState: rememberMeState,
  reducers: {
    clickedRememberMe: (state, action) => {
      state.rememberMeState = action.payload;
      if (state.rememberMeState) {
        globalRememberMe = true;
      }
    },
  },
});

export const { setLogin } = signinSlice.actions;
export const signinReducer = signinSlice.reducer;
export const { clickedRememberMe } = rememeberMeSlice.actions;
export const rememeberMeReducer = rememeberMeSlice.reducer;
